import { Injectable } from '@angular/core';
import { RxTextCompositeComponent } from '@nrwl/rx-forms';
import { Doctor } from '@nrwl/rx-models';
import { DialogsConfigService } from '../dialogs-config.service';

@Injectable({
  providedIn: 'root',
})
export class TrustedPartiesDialogConfigService extends DialogsConfigService {
  constructor() {
    super();
  }

  public showDoctorDetails(doctor?: Doctor) {
    return {
      hideFooter: true,
      payload: {
        title: !doctor ? 'New Trusted 3rd Party' : 'Edit Trusted 3rd Party',
        placeholder: 'Folder',
        data: doctor,
      },
    };
  }

  public confirmRemoving() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: `Alert`,
        tip: 'Are you sure you want to archive this Trusted 3rd Party?',
        buttons: this.SubmitDismissButtons('Archive'),
      },
    };
  }
}
